import { postToAgents } from "./PlaybookApi";

const PlaybookRuleService = {
	/**
	 * Every live rule the firm has set for its playbooks.
	 *
	 * @return {Promise<Array>}
	 */
	listRules() {
		return postToAgents({ operationId: "listPlaybookRules", body: {} });
	},

	/**
	 * Sets a rule at one scope, or turns a rejection into a rule for the run's client.
	 *
	 * @param {Object} params { scopeKind, scopeId?, text?, fromDecisionId? }
	 * @return {Promise<Object>} the rule
	 */
	createRule({ scopeKind, scopeId, text, fromDecisionId }) {
		return postToAgents({ operationId: "createPlaybookRule", body: { scopeKind, scopeId, text, fromDecisionId } });
	},

	/**
	 * Retires a rule so later runs are not handed it.
	 *
	 * @param {Object} params { ruleId }
	 * @return {Promise<Object>}
	 */
	retireRule({ ruleId }) {
		return postToAgents({ operationId: "retirePlaybookRule", body: { ruleId } });
	},

	/**
	 * The facts people have confirmed about one client, or about every client.
	 *
	 * @param {Object} params { clientId? }
	 * @return {Promise<Array>}
	 */
	listFacts({ clientId } = {}) {
		return postToAgents({ operationId: "listClientFacts", body: { clientId } });
	},

	/**
	 * Records a fact about a client under the confirming person's name.
	 *
	 * @param {Object} params { clientId, text, sourceRunId? }
	 * @return {Promise<Object>} the fact
	 */
	confirmFact({ clientId, text, sourceRunId }) {
		return postToAgents({ operationId: "confirmClientFact", body: { clientId, text, sourceRunId } });
	},

	/**
	 * Retires a fact that no longer holds.
	 *
	 * @param {Object} params { factId }
	 * @return {Promise<Object>}
	 */
	retireFact({ factId }) {
		return postToAgents({ operationId: "retireClientFact", body: { factId } });
	},

	/**
	 * The scopes a rule can be set at, for the Rules screen.
	 *
	 * @return {Array} [{ value, label }]
	 */
	ruleScopeChoices() {
		const choices = [
			{ value: "firm", label: "Firm-wide — every playbook, every client" },
			{ value: "playbook", label: "One playbook, every client" },
			{ value: "client", label: "One client, every playbook" },
		];
		return choices;
	},
};

export default PlaybookRuleService;
